import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import type { NotificationSubscriptionResponseDto } from '@api/devices';
import { DeviceService } from '@devices';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatTooltip],
  selector: 'avs-device-notification-subscription',
  styleUrl: './device-notification-subscription.component.scss',
  templateUrl: './device-notification-subscription.component.html',
})
export class DeviceNotificationSubscriptionComponent {
  deviceId = input.required<string>();

  protected subscription = signal<NotificationSubscriptionResponseDto | null>(null);

  private deviceService = inject(DeviceService);

  constructor() {
    effect(() => {
      const deviceId = this.deviceId();

      if (deviceId) {
        this.deviceService.getNotificationSubscription(deviceId).subscribe(data => {
          this.subscription.set(data);
        });
      }
    });
  }
}
